import { EVENT_LEVELS } from '@/modules/Events/constants';
import BaseModel from '../base';

import constants from './constants';
import glossary from './glossary';
import Quota from '../quota';

export default class Exchange extends BaseModel {
  constructor(exchange, url) {
    super(exchange, url);

    this.id = exchange.id;
    this.quota_id = exchange.quota_id;
    this.event_id = exchange.event_id;
    this.level = exchange.level;
    this.parent_id = exchange.parent_id;
    this.target_id = exchange.target_id;
    this.status = exchange.status;
    this.created_at = exchange.created_at;
    this.updated_at = exchange.updated_at;

    this.subordination = exchange.subordination;
    this.quotas = (exchange.quotas || []).map((i) => new Quota(i, 'quotas'));
    this.request_organizers_count = exchange.request_organizers_count;

    this.territory_name = exchange.territory_name;
    this.main_event = exchange.main_event;
    this.organizer = exchange.organizer;
    this.request_organizer = undefined;
  }

  get statusData() {
    const { EXCHANGE_STATUS_DATA } = glossary;
    return EXCHANGE_STATUS_DATA[this.status];
  }

  get searchParam() {
    const { level } = this;
    return {
      [EVENT_LEVELS.federal]: 'region_id',
      [EVENT_LEVELS.regional]: 'region_id',
      [EVENT_LEVELS.municipal]: 'municipality_id',
      [EVENT_LEVELS.local]: 'municipality_id',
    }[level];
  }

  get isRegion() {
    const { searchParam } = this;
    return searchParam === 'region_id';
  }

  get isLocal() {
    const { level } = this;
    return level === EVENT_LEVELS.local;
  }

  get isLocalRequest() {
    const { EXCHANGE_STATUS } = constants;
    const { isLocal, status } = this;
    return isLocal && (status === EXCHANGE_STATUS.market);
  }

  get requestsCount() {
    const { EXCHANGE_STATUS } = constants;
    if (EXCHANGE_STATUS.market === this.status) return this.request_organizers_count;
    return 0;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
